module.exports = __webpack_public_path__ + "img/user_2x.09236f10.png";